'use client';

import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

const BRAND = '#3757FF';

export default function LearnCTA() {
    const sectionRef = useRef<HTMLElement>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setVisible(true); }, { threshold: 0.1 });
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <section ref={sectionRef} className="py-28 px-6 md:px-10" style={{ background: '#FAFAFA' }}>
            <div className="max-w-5xl mx-auto">
                <div
                    className={`rounded-3xl p-12 md:p-16 text-center relative overflow-hidden transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                    style={{ background: BRAND }}
                >
                    {/* Background orbs */}
                    <div className="absolute top-0 left-0 w-80 h-80 rounded-full pointer-events-none" style={{ background: 'rgba(255,255,255,0.04)', transform: 'translate(-40%, -40%)' }} />
                    <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full pointer-events-none" style={{ background: 'rgba(255,255,255,0.04)', transform: 'translate(30%, 30%)' }} />

                    <div className="relative z-10">
                        <div
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-700 uppercase tracking-widest mb-8"
                            style={{ background: 'rgba(255,255,255,0.15)', color: 'white', letterSpacing: '0.15em' }}
                        >
                            Wisly Learn
                        </div>
                        <h2
                            className="font-display font-800 text-white mb-5"
                            style={{ fontSize: 'clamp(2rem, 4vw, 3.5rem)', lineHeight: 1.05, letterSpacing: '-0.025em' }}
                        >
                            Ready to start learning?
                        </h2>
                        <p className="text-lg mb-10 mx-auto" style={{ color: 'rgba(255,255,255,0.75)', maxWidth: '480px', lineHeight: 1.6 }}>
                            Join thousands of students already discovering, learning, and growing on Wisly Learn.
                        </p>

                        <div className="flex flex-wrap items-center justify-center gap-4">
                            <a
                                href="/early-access"
                                className="inline-flex items-center gap-2 px-8 py-4 rounded-xl text-sm font-700 transition-all duration-300"
                                style={{ background: 'white', color: BRAND }}
                                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.transform = 'translateY(-2px)'; (e.currentTarget as HTMLElement).style.boxShadow = '0 12px 36px rgba(0,0,0,0.15)'; }}
                                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.transform = 'translateY(0)'; (e.currentTarget as HTMLElement).style.boxShadow = 'none'; }}
                            >
                                Request early access
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2.5 7h9M7.5 3.5l3.5 3.5-3.5 3.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" /></svg>
                            </a>
                            <Link
                                href="/wisly"
                                className="inline-flex items-center gap-2 px-8 py-4 rounded-xl text-sm font-600 transition-all duration-300"
                                style={{ color: 'rgba(255,255,255,0.85)', border: '1.5px solid rgba(255,255,255,0.25)' }}
                                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.6)'; (e.currentTarget as HTMLElement).style.color = 'white'; }}
                                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.25)'; (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.85)'; }}
                            >
                                Back to Wisly
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
